module.exports = __webpack_public_path__ + "static/img/02-04.7cef1b3e.png";